import { AccountId, Any, OrderSide, OrderType, PairSymbol } from "@cede/types";

export type GetPortfolioFromCexParams = {
  vaultId: string;
  accountNames: string[];
  provider: Any;
};

export type FetchAllTickersFromSymoblsParams = {
  vaultId: string;
  accountName: string;
  symbols: string[];
  provider: Any;
};

export type FetchAllPairsParams = {
  vaultId: string;
  accountName: string;
  provider: Any;
};

export type PostMarketOrderParams = {
  tradeRequest: TradeRequest;
  provider: Any;
};

export type TradeRequest = {
  accountId: AccountId;
  pairSymbol: PairSymbol;
  orderSide: OrderSide;
  orderType: OrderType;
  price?: string;
  amount?: string;
  orderId?: string; // Only for editing
  type?: OrderType; // Only for editing
};
